import React, { FC } from 'react'
import { FixedLayout } from 'components/Layout'
import { LoginTemplate } from 'components/Templates'

const Login: FC = () => {
  return (
    <FixedLayout title={'ログイン'}>
      <LoginTemplate />
    </FixedLayout>
  )
}

export default Login
